import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "input-group" };
const _hoisted_2 = ["id", "disabled", "value"];
const _hoisted_3 = {
    value: "",
    disabled: ""
};
const _hoisted_4 = {
    key: 0,
    label: "Visible Molecules"
};
const _hoisted_5 = ["value"];
const _hoisted_6 = {
    key: 1,
    label: "Hidden Molecules"
};
const _hoisted_7 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("select", {
                class: "form-select form-select-sm",
                id: _ctx.id,
                disabled: _ctx.disabled || _ctx.filteredMolecules.length === 0,
                onInput: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                value: _ctx.modelValue
            }, [
                _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.filteredMolecules.length === 0
                    ? "No molecules available"
                    : "Select a molecule..."), 1),
                (_ctx.visibleMolecules.length > 0)
                    ? (_openBlock(), _createElementBlock("optgroup", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMolecules, (opt) => {
                            return (_openBlock(), _createElementBlock("option", {
                                value: opt.id,
                                key: opt.id
                            }, _toDisplayString(opt.title), 9, _hoisted_5));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.hiddenMolecules.length > 0)
                    ? (_openBlock(), _createElementBlock("optgroup", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiddenMolecules, (opt) => {
                            return (_openBlock(), _createElementBlock("option", {
                                value: opt.id,
                                key: opt.id
                            }, _toDisplayString(opt.title), 9, _hoisted_7));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 40, _hoisted_2)
        ]),
        _createVNode(_component_FormElementDescription, { description: _ctx.description }, null, 8, ["description"])
    ]));
}
